import { LocalizationModule } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { Component, computed, effect, input, signal } from '@angular/core';
import { AddressDto } from '@digiwall/goliath-contacts/proxy';
import { InformationsAuditedEntityComponent } from '@digiwall/goliath-core';
import { CustomerProjectDto } from '@digiwall/goliath-documents/proxy';
import { DocIconAddressComponent } from '../../../base-docs/detail/doc-ui-components/doc-icon-address/doc-icon-address.component';
import { DocRole, LocalityDto, LocalityService } from '@digiwall/goliath-core/proxy';
import { NewId } from '@digiwall/core';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  selector: 'document-customer-project-side-panel',
  templateUrl: './customer-project-side-panel.component.html',
  imports: [
    CommonModule,
    LocalizationModule,
    InformationsAuditedEntityComponent,
    DocIconAddressComponent,
  ],
})
export class CustomerProjectSidePanelComponent {
  entity = input.required<CustomerProjectDto>();
  protected deliveryAddressForm = input<AddressDto>();
  fileBlobUrl = input<string | Blob>();

  localitySignal = signal<LocalityDto>(null);

  deliveryAddressLabel = computed(() => {
    let locality = this.localitySignal();
    const parts = [
      this.deliveryAddressForm()?.street,
      locality?.postalCode,
      locality?.city?.current,
    ];
    return parts.filter(x => x?.length > 0).join(' ');
  });

  protected docRole = DocRole;

  /**
   *
   */
  constructor(
    private localityService: LocalityService,
    private router: Router,
  ) {
    effect(() => {
      if (this.deliveryAddressForm()?.localityId != null) {
        this.localityService.get(this.deliveryAddressForm().localityId).subscribeOnce(locality => {
          this.localitySignal.set(locality);
        });
      }
    });
  }

  protected redirectToThirdParty(thirdPartyId: string = NewId) {
    let url = window.location.href.replace(this.router.url, '');
    url += `/third-parties/customers/${thirdPartyId}`;
    window.open(url, '_blank');
  }
}
